import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { SearchSettingsFooter, SearchSettingsFooterProps } from "./SearchSettingsFooter";

import "./BaseSettingsContainer.css";

interface BaseSettingsContainerProps {
    onClick?: () => void;
    id?: string;
    className?: string;
    footerClassName?: string;
    style?: React.CSSProperties;
}

abstract class BaseSettingsContainerState {
    public isSaveSettingsChecked: boolean;
}

abstract class BaseSettingsContainer<TProps extends BaseSettingsContainerProps, TState extends BaseSettingsContainerState> extends BaseReactComponent<TProps, TState> {
    protected abstract getHeaders(): { node: React.ReactNode, id: string }[];
    protected abstract getColumnData(): { node: React.ReactNode, id: string }[];
    protected abstract getSearchSettingsFooterProps(): SearchSettingsFooterProps;
    protected abstract shouldTriggerOkActionOnOutsideClick(): boolean;

    public componentDidMount(): void {
        super.setOverlay(
            this.props.id + "Overlay",
            {
                transparent: true,
                onClicked: () => this.shouldTriggerOkActionOnOutsideClick() && this.getSearchSettingsFooterProps().onOk()
            }
        );
    }

    public render(): JSX.Element {
        const settingsclass = `filter-component filter-component-responsive ${this.props.className}`;
        const footerClass = `footer-responsive ${this.props.footerClassName}`;
        return (
            <div
                id={this.props.id}
                className={settingsclass}
                style={this.props.style}
                onClick={() => this.props.onClick?.()}
                data-cy="settingsContainer"
            >
                <table className="f-content">
                    <thead>
                        <tr>
                            {this.getHeaders().map(header => <th key={header.id}>{header.node}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {this.getColumnData().map(data => <td key={data.id}>{data.node}</td>)}
                        </tr>
                    </tbody>
                </table>
                <div className={footerClass}>
                    <SearchSettingsFooter {...this.getSearchSettingsFooterProps()} />
                </div>
            </div>
        );
    }
}

export { BaseSettingsContainer, BaseSettingsContainerProps, BaseSettingsContainerState };
